<template>
  <div class="ps-personal-account-simple-select2 v-select2">
     <VueSelect2
        :placeholder="currentPlaceHolder()"
        :options="dataSource.map(item => ({id: item.code || item.id, text: item.label || item.text || item.name}))"
        v-model="selectedCode"
        :settings="select2Settings()"
        :disabled="disabled === true"
        @open="onOpen"
        @click="onOpen"
        :key="selectKey + ' ' + (addKey || '')"
        @close.stop="$emit('close', $event)"
        @focusout.stop="$emit('focusout', $event)"
    >
    </VueSelect2>
  </div>
</template>
<script>
import VueSelect2 from 'vue3-select2-component';
import VModelMixin from "@/mixins/v-model.mixin";

export default {
  name: "SimpleSelect2",
  components: {VueSelect2},
  props: ['dataSource', 'disabled', 'placeholder', 'addKey'],
  mixins: [VModelMixin],
  emits: ['focusout', 'close', 'open', 'select'],
  mounted() {
    let lastWidth = window.innerWidth;
    window.addEventListener('resize', () => {
      if (window.innerWidth !== lastWidth) {
        lastWidth = window.innerWidth;
        this.selectKey = this.selectKey + 1;
      }
    });
  },
  methods: {
    select2Settings() {
      return {
        dropdownPosition: 'below',
        containerCssClass: 'v-select2',

      };
    },
    onOpen(ev) {
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      if (!isTouchDevice) {
        const e = document.querySelector('input.select2-search__field');
        if (e) e.focus();
      }
      this.$emit('open', ev);
    },
    currentPlaceHolder() {
      const selItem = this.dataSource
          .find(item => (item.code || '').toString() === (this.selectedCode || '').toString());
      if (!selItem) {
        return this.placeholder;
      }
      return selItem.label;
    }
  },
  computed: {
    selectedCode: {
      get() {
        return String(this.currentValue);
      },
      set(value) {
        this.currentValue = String(value);
      }
    },
  },
  data() {
    return {
      selectKey: 1,
    }
  }
}
</script>
<style scoped lang="scss"></style>
